import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableLogin = Loadable({
  loader: function loader() {
    return import('../Login.jsx');
  },
  loading: ComponentLoading
});
export default LoadableLogin;